"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tabs = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _TabGroup = _interopRequireDefault(require("./components/TabGroup"));
var _colors = require("../../theme/colors");
var _excluded = ["classes", "className", "dataMetrics", "dynamicTabs", "indicatorAlign", "indicatorColor", "indicatorHide", "mode", "onChange", "onClose", "staticTabs", "tabRef", "tabWidth", "tabsAlign", "variant", "value"],
  _excluded2 = ["container"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = function styles(theme) {
  return {
    container: {
      boxShadow: "inset 0px -1px ".concat(_colors.opacity.black[8]),
      height: theme.spacing(8),
      padding: theme.spacing(2, 2, 0)
    },
    // can expose more TabGroup classes as needed
    flexContainer: {}
  };
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_tabs'
  },
  dynamicTabs: [],
  mode: 'static',
  onChange: function onChange() {},
  onClose: function onClose() {},
  staticTabs: [],
  tabWidth: 150
};
var tabMinWidth = 78;
var edgeWidth = 16; // edge width on each side

/**
 * Tabs is used for rendering a mix of fixed and dynamic tabs.
 */
var Tabs = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tabs, _React$Component);
  var _super = _createSuper(Tabs);
  function Tabs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tabs);
    _this = _super.call(this, props);
    _this.updateComponentWidth = _this.updateComponentWidth.bind((0, _assertThisInitialized2["default"])(_this));
    _this.componentRef = /*#__PURE__*/_react["default"].createRef();
    _this.debouncedUpdateComponentWidth = (0, _lodash.debounce)(_this.updateComponentWidth, 200);
    _this.state = {
      componentWidth: 0
    };
    return _this;
  }
  (0, _createClass2["default"])(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateComponentWidth();
      window.addEventListener('resize', this.debouncedUpdateComponentWidth);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        dynamicTabs = _this$props.dynamicTabs,
        staticTabs = _this$props.staticTabs;
      if (prevProps.dynamicTabs !== dynamicTabs || prevProps.staticTabs !== staticTabs) {
        this.updateComponentWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedUpdateComponentWidth);
    }
  }, {
    key: "updateComponentWidth",
    value: function updateComponentWidth() {
      var componentWidth = this.state.componentWidth;
      var updatedComponentWidth = this.componentRef.current ? this.componentRef.current.clientWidth : 0;
      if (componentWidth !== updatedComponentWidth) {
        this.setState({
          componentWidth: updatedComponentWidth
        });
      }
    }
  }, {
    key: "widthAvailablePerTab",
    value: function widthAvailablePerTab() {
      var componentWidth = this.state.componentWidth;
      var _this$props2 = this.props,
        dynamicTabs = _this$props2.dynamicTabs,
        staticTabs = _this$props2.staticTabs;
      if (dynamicTabs.length + staticTabs.length === 0) {
        return tabMinWidth;
      }
      return (Math.abs(componentWidth) - edgeWidth * 2) / (dynamicTabs.length + staticTabs.length);
    }
  }, {
    key: "calculateTabWidth",
    value: function calculateTabWidth() {
      var widthPerTab = this.widthAvailablePerTab();
      var _this$props3 = this.props,
        mode = _this$props3.mode,
        tabWidth = _this$props3.tabWidth,
        variant = _this$props3.variant;
      if (variant === 'fullWidth' && mode === 'static') {
        return Math.max(widthPerTab, tabMinWidth);
      }
      if (tabWidth) {
        return tabWidth;
      }

      // width should be >= tabMinWidth and <= tabWidth
      return Math.min(Math.max(widthPerTab, tabMinWidth), tabWidth);
    }
  }, {
    key: "getCorrectTabWidth",
    value: function getCorrectTabWidth(customWidth) {
      var defaultTabWidth = this.calculateTabWidth();
      if (customWidth && customWidth >= tabMinWidth) {
        return customWidth;
      }
      return defaultTabWidth;
    }
  }, {
    key: "shouldEnableScroll",
    value: function shouldEnableScroll() {
      var componentWidth = this.state.componentWidth;
      // The scroll should only be enabled when the tabs are greater then the width of the container
      var _this$props4 = this.props,
        dynamicTabs = _this$props4.dynamicTabs,
        staticTabs = _this$props4.staticTabs,
        variant = _this$props4.variant;
      if (variant === 'fullWidth') {
        return false;
      }
      var tableWidth = componentWidth;
      var tabWidth = this.calculateTabWidth();
      var allTabs = [].concat((0, _toConsumableArray2["default"])(dynamicTabs), (0, _toConsumableArray2["default"])(staticTabs));
      var totalNumberOfTabs = allTabs.length;
      var customTabWithTotal = allTabs.reduce(function (accumulator, currentValue) {
        var currentTabWidth = currentValue.props.tabWidth;
        if (currentTabWidth && currentTabWidth > tabMinWidth) {
          // eslint-disable-next-line no-param-reassign
          accumulator += currentTabWidth - tabMinWidth;
        }
        return accumulator;
      }, 0);
      var defaultTabTotal = totalNumberOfTabs * tabWidth;
      var totalTabWidth = defaultTabTotal + customTabWithTotal;
      return tableWidth < totalTabWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        classes = _this$props5.classes,
        className = _this$props5.className,
        dataMetrics = _this$props5.dataMetrics,
        dynamicTabs = _this$props5.dynamicTabs,
        indicatorAlign = _this$props5.indicatorAlign,
        indicatorColor = _this$props5.indicatorColor,
        indicatorHide = _this$props5.indicatorHide,
        mode = _this$props5.mode,
        onChange = _this$props5.onChange,
        onClose = _this$props5.onClose,
        staticTabs = _this$props5.staticTabs,
        tabRef = _this$props5.tabRef,
        tabWidth = _this$props5.tabWidth,
        tabsAlign = _this$props5.tabsAlign,
        variant = _this$props5.variant,
        value = _this$props5.value,
        rest = (0, _objectWithoutProperties2["default"])(_this$props5, _excluded);
      var containerClass = classes.container,
        tabGroupClasses = (0, _objectWithoutProperties2["default"])(classes, _excluded2);
      var isFullWidth = variant === 'fullWidth';
      var enableScroll = this.shouldEnableScroll();
      var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);

      // This allows us to pass props down to the Tabs
      var dynamicTabsWithProps = dynamicTabs.map(function (child, index) {
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          fixed: false,
          id: "dynamicTab-".concat(index),
          isFullWidth: isFullWidth,
          key: child.props.value || "tab-".concat(index),
          mode: mode,
          onClose: onClose,
          tabWidth: _this2.getCorrectTabWidth(child.props.tabWidth),
          type: 'dynamic',
          value: child.props.value || index
        });
      });
      var staticTabsWithProps = staticTabs.map(function (child, index) {
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          fixed: true,
          id: "staticTab-".concat(index),
          isFullWidth: isFullWidth,
          key: child.props.value || "tab-".concat(index),
          mode: mode,
          tabWidth: _this2.getCorrectTabWidth(child.props.tabWidth),
          type: 'static',
          value: child.props.value || index
        });
      });

      // The tabs require that the static tabs show up first in the table
      var orderedChildren = [].concat((0, _toConsumableArray2["default"])(staticTabsWithProps), (0, _toConsumableArray2["default"])(dynamicTabsWithProps));
      var tabsComponent = /*#__PURE__*/_react["default"].createElement(_TabGroup["default"], (0, _extends2["default"])({
        classes: tabGroupClasses,
        dataMetrics: {
          root: mergedDataMetrics.root
        },
        indicatorAlign: indicatorAlign,
        indicatorColor: indicatorColor,
        indicatorHide: indicatorHide,
        mode: mode,
        onChange: onChange,
        ref: this.componentRef,
        scrollButtons: enableScroll ? 'on' : undefined,
        tabsAlign: tabsAlign,
        value: value,
        variant: enableScroll ? 'scrollable' : 'standard'
      }, rest), orderedChildren);
      if (mode === 'static') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, tabsComponent);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(containerClass, className),
        ref: this.componentRef
      }, tabsComponent);
    }
  }]);
  return Tabs;
}(_react["default"].Component);
exports.Tabs = Tabs;
Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   * 'flexContainer' of MUITabs is currently available to be overriden/extended.
   * e.g.
   * classes={{
   *   flexContainer: classes.container,
   * }}
   */
  classes: _propTypes["default"].object,
  /**
   * You can pass down a className and modify the container styles as needed.
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Dynamic are for closable tabs.
   * You must pass in an array of the Tab Components
   * See **[Tab](/#/Components/Tab)** for additional information
   * */
  dynamicTabs: _propTypes["default"].arrayOf(function (propValue, key, componentName, location, propFullName) {
    var pattern = /Tab/;
    var requiredComponentName = new RegExp(pattern);
    if (!requiredComponentName.test(propValue[key].type.displayName)) {
      return new Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName, " validation failed - Fuse Tab component required"));
    }
  }),
  /**
   * The alignment of the indicator: `top` `bottom`
   * */
  indicatorAlign: _propTypes["default"].string,
  /**
   * `primary` `secondary` the color of the indicator
   * */
  indicatorColor: _propTypes["default"].string,
  /**
   * indicatorHide will disable the highlighted indicator.
   * */
  indicatorHide: _propTypes["default"].bool,
  /**
   *  `dynamic` for closable tabs `static` ( default ) for traditional tabs. These will be centered text and no padding.
   */
  mode: _propTypes["default"].string,
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes["default"].func,
  /**
   * Callback fired when close icon is clicked
   * returns the index of the tab if no value prop is set on a tab
   * otherwise, it returns the value you set
   * As well as the customReturnedProps - see Single Tab for additional details on how to use customReturnedProps
   */
  onClose: _propTypes["default"].func,
  /**
   * StaticTabs are for traditional tabs that can not close. These will be centered text.
   * You must pass in an array of the Tab Components
   * See **[Tab](/#/Components/Tab)** for additional information
   * */
  staticTabs: _propTypes["default"].arrayOf(function (propValue, key, componentName, location, propFullName) {
    var pattern = /Tab/;
    var requiredComponentName = new RegExp(pattern);
    if (!requiredComponentName.test(propValue[key].type.displayName)) {
      return new Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName, " validation failed - Fuse Tab component required"));
    }
  }),
  /**
   * If 'true', indicator (top highlight color) will be hidden.  It is intended to be used in dark background.
   */
  tabRef: _propTypes["default"].element,
  /**
   * Determines the Tab alignment of inside Tabs.
   */
  tabsAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  /**
   * Sets all tabs to the number specified. This must be a number. Min Tab width is 80px.
   * NOTE: If you do not want all tabs the same width change the width value in the
   * tab component being passed in. (See tab component for additional information)
   */
  tabWidth: _propTypes["default"].number,
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  /**
   * Full Width: allows the tabs full width. If there is not enough space it will add the scrolling tabs.
   */
  variant: _propTypes["default"].oneOf(['fullWidth'])
} : {};
var TabsWithStyles = (0, _styles.withStyles)(styles)(Tabs);
TabsWithStyles.displayName = 'Tabs';
var _default = TabsWithStyles;
exports["default"] = _default;